import $ from "jquery";

class BlogFilter {
	constructor() {
		this.filtersForm = $(".js-blog-filters-form");
		if (!this.filtersForm.length) {
			return;
		}

		this.industryCheckboxes = this.filtersForm.find('input[name="industry[]"]');
		this.categoryCheckboxes = this.filtersForm.find('input[name="category[]"]');
		this.resultsContainer = $(".js-load-more-target");
		this.paginationContainer = $(".dr-pagination-wrapper");
		this.featuredPostsContainer = $(".dr-blog-posts-featured");
		this.skeleton = $("#hits_skeleton");

		this.ajaxUrl = window.drAjax?.ajaxurl;
		this.nonce = window.drAjax?.nonce;
		this.perPage = 9;

		// Detect if we're on an author page
		this.isAuthorPage = window.location.pathname.toLowerCase().includes("/blog/author/");
		this.authorSlug = this.isAuthorPage ? window.location.pathname.match(/\/blog\/author\/([^\/]+)\/?/)?.[1] : null;

		// Set the base URL appropriately
		if (this.isAuthorPage && this.authorSlug) {
			// For author pages, keep the author URL as base
			this.blogBaseUrl = window.location.origin + "/blog/author/" + this.authorSlug + "/";
		} else {
			// For regular blog pages
			this.blogBaseUrl = window.drAjax?.blog_url || window.location.origin + (window.location.pathname.toLowerCase().startsWith("/blog") ? "/blog/" : window.location.pathname.match(/^(\/[^\/]+\/)/)?.[0] || "/");
		}

		if (this.blogBaseUrl && !this.blogBaseUrl.endsWith("/")) {
			this.blogBaseUrl += "/";
		}

		this.currentPage = 1;
		this.isLoading = false;
		this.currentXhr = null;
		this.urlCategoryPathProcessed = false;

		this.init();
	}

	init() {
		this.updateCurrentPageFromUrl();
		this.loadInitialStateFromUrlAndPath();
		this.bindEvents();
	}

	updateCurrentPageFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has("paged")) {
			this.currentPage = parseInt(urlParams.get("paged"), 10) || 1;
		} else {
			const pathMatch = window.location.pathname.match(/\/page\/(\d+)\/?$/);
			if (pathMatch && pathMatch[1]) {
				this.currentPage = parseInt(pathMatch[1], 10) || 1;
			}
		}
		this.currentPage = Math.max(1, this.currentPage);
	}

	hasActiveUrlFilters() {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.has("category") || urlParams.has("category[]") || urlParams.has("industry") || urlParams.has("industry[]");
	}

	updateSingleCheckboxState(checkboxElement, shouldBeChecked) {
		const $checkbox = $(checkboxElement);
		if (!$checkbox.length) return;

		$checkbox.prop("checked", shouldBeChecked);
		const $listItem = $checkbox.closest("li.ais-RefinementList-item");
		if (shouldBeChecked) {
			$listItem.addClass("ais-RefinementList-item--selected");
		} else {
			$listItem.removeClass("ais-RefinementList-item--selected");
		}
	}

	loadInitialStateFromUrlAndPath() {
		const urlParams = new URLSearchParams(window.location.search);
		let categorySlugsFromQuery = [];
		let industrySlugsFromQuery = [];

		const pathName = window.location.pathname;
		let categorySlugFromPath = null;
		let pageFromPath = null;

		const categoryPathRegex = /\/blog\/category\/([^/]+)(?:\/page\/(\d+))?\/?$/i;
		const categoryPathMatch = pathName.match(categoryPathRegex);

		if (categoryPathMatch && categoryPathMatch[1]) {
			categorySlugFromPath = categoryPathMatch[1];
			this.urlCategoryPathProcessed = true;
			if (categoryPathMatch[2]) {
				pageFromPath = parseInt(categoryPathMatch[2], 10) || 1;
				this.currentPage = pageFromPath;
			}
		}

		if (!pageFromPath) {
			this.updateCurrentPageFromUrl();
		}

		const categoryParam = urlParams.get("category");
		if (categoryParam) {
			categorySlugsFromQuery = categoryParam
				.split(",")
				.map((s) => s.trim())
				.filter((s) => s);
		}

		const industryParam = urlParams.get("industry");
		if (industryParam) {
			industrySlugsFromQuery = industryParam
				.split(",")
				.map((s) => s.trim())
				.filter((s) => s);
		}

		if (categorySlugFromPath) {
			categorySlugsFromQuery.push(categorySlugFromPath);
		}
		categorySlugsFromQuery = [...new Set(categorySlugsFromQuery)];
		industrySlugsFromQuery = [...new Set(industrySlugsFromQuery)];

		let specificCategorySelected = false;
		this.categoryCheckboxes.each((_index, checkbox) => {
			const $checkbox = $(checkbox);
			const value = $checkbox.val();
			if (value === "") return;
			if (categorySlugsFromQuery.includes(value)) {
				this.updateSingleCheckboxState($checkbox, true);
				specificCategorySelected = true;
			} else {
				this.updateSingleCheckboxState($checkbox, false);
			}
		});
		this.updateSingleCheckboxState(this.categoryCheckboxes.filter('[value=""]'), !specificCategorySelected);

		let specificIndustrySelected = false;
		this.industryCheckboxes.each((_index, checkbox) => {
			const $checkbox = $(checkbox);
			const value = $checkbox.val();
			if (value === "") return;
			if (industrySlugsFromQuery.includes(value)) {
				this.updateSingleCheckboxState($checkbox, true);
				specificIndustrySelected = true;
			} else {
				this.updateSingleCheckboxState($checkbox, false);
			}
		});
		this.updateSingleCheckboxState(this.industryCheckboxes.filter('[value=""]'), !specificIndustrySelected);

		if (this.urlCategoryPathProcessed) {
			const currentFiltersForReplace = this.getSelectedFilters();
			const paramsForReplace = new URLSearchParams();
			let replacePath = this.blogBaseUrl;

			if (currentFiltersForReplace.category.length === 1 && currentFiltersForReplace.industry.length === 0 && this.currentPage === 1) {
				replacePath = this.blogBaseUrl + "category/" + currentFiltersForReplace.category[0] + "/";
			} else {
				if (currentFiltersForReplace.category.length > 0) {
					paramsForReplace.set("category", currentFiltersForReplace.category.join(","));
				}
				if (currentFiltersForReplace.industry.length > 0) {
					paramsForReplace.set("industry", currentFiltersForReplace.industry.join(","));
				}
				if (this.currentPage > 1) {
					paramsForReplace.set("paged", this.currentPage);
				}
			}
			const newSearchString = paramsForReplace.toString();
			let newUrl = replacePath + (newSearchString ? `?${newSearchString}` : "");

			if (newUrl !== this.blogBaseUrl && newUrl.endsWith("/") && !newSearchString) {
				newUrl = newUrl.slice(0, -1);
			}

			const currentCleanHref = window.location.href.replace(/\/?(\?|#|$)/, "").replace(/\/+$/, "");
			const newCleanHref = newUrl.replace(/\/?(\?|#|$)/, "").replace(/\/+$/, "");

			if (newCleanHref !== currentCleanHref) {
				history.replaceState({ filters: currentFiltersForReplace, page: this.currentPage }, "", newUrl);
			}
		}

		const finalFilters = this.getSelectedFilters();
		const shouldApplyFiltersNow = finalFilters.category.length > 0 || finalFilters.industry.length > 0 || this.currentPage > 1;

		if (shouldApplyFiltersNow) {
			this.applyFilters(false);
		}
		this.toggleFeaturedPostsVisibility();
	}

	getSelectedFilters() {
		const filters = {
			category: [],
			industry: [],
		};

		this.categoryCheckboxes.each((_index, checkbox) => {
			const $checkbox = $(checkbox);
			if ($checkbox.is(":checked") && $checkbox.val() !== "") {
				filters.category.push($checkbox.val());
			}
		});

		this.industryCheckboxes.each((_index, checkbox) => {
			const $checkbox = $(checkbox);
			if ($checkbox.is(":checked") && $checkbox.val() !== "") {
				filters.industry.push($checkbox.val());
			}
		});
		return filters;
	}

	handleUserFilterChange(changedCheckbox) {
		const $changedCheckbox = $(changedCheckbox);
		const isChecked = $changedCheckbox.is(":checked");
		const value = $changedCheckbox.val();
		const $groupCheckboxes = $changedCheckbox.attr("name") === "category[]" ? this.categoryCheckboxes : this.industryCheckboxes;

		if (value === "") {
			if (isChecked) {
				$groupCheckboxes.not($changedCheckbox).each((_idx, el) => {
					this.updateSingleCheckboxState(el, false);
				});
				this.updateSingleCheckboxState($changedCheckbox, true);
			} else {
				const anyOtherSpecificChecked = $groupCheckboxes.not($changedCheckbox).is(":checked");
				if (!anyOtherSpecificChecked) {
					this.updateSingleCheckboxState($changedCheckbox, true);
				}
			}
		} else {
			this.updateSingleCheckboxState($changedCheckbox, isChecked);
			if (isChecked) {
				this.updateSingleCheckboxState($groupCheckboxes.filter('[value=""]'), false);
			} else {
				const anyOtherSpecificChecked = $groupCheckboxes.not('[value=""]').not($changedCheckbox).is(":checked");
				if (!anyOtherSpecificChecked) {
					this.updateSingleCheckboxState($groupCheckboxes.filter('[value=""]'), true);
				}
			}
		}
		this.applyFilters();
	}

	getPageUrl(pageNumber) {
		const selectedFilters = this.getSelectedFilters();
		const params = new URLSearchParams();
		let pathForUrl = this.blogBaseUrl;

		if (selectedFilters.category.length > 0) {
			params.set("category", selectedFilters.category.join(","));
		}

		if (selectedFilters.industry.length > 0) {
			params.set("industry", selectedFilters.industry.join(","));
		}

		if (pageNumber > 1) {
			params.set("paged", pageNumber);
		} else {
			params.delete("paged");
		}

		const queryString = params.toString();
		let finalUrl = pathForUrl + (queryString ? `?${queryString}` : "");

		if (finalUrl !== this.blogBaseUrl && finalUrl.endsWith("/") && !queryString) {
			finalUrl = finalUrl.slice(0, -1);
		}

		return finalUrl;
	}

	updateUrl() {
		const selectedFilters = this.getSelectedFilters();
		const params = new URLSearchParams();
		let pathForUrl = this.blogBaseUrl;

		if (selectedFilters.category.length > 0) {
			params.set("category", selectedFilters.category.join(","));
		}
		if (selectedFilters.industry.length > 0) {
			params.set("industry", selectedFilters.industry.join(","));
		}
		if (this.currentPage > 1) {
			params.set("paged", this.currentPage);
		}

		const newQueryString = params.toString();
		let newUrl = pathForUrl + (newQueryString ? `?${newQueryString}` : "");

		if (newUrl !== this.blogBaseUrl && newUrl.endsWith("/") && !newQueryString) {
			newUrl = newUrl.slice(0, -1);
		}

		const state = {
			filters: selectedFilters,
			page: this.currentPage,
		};

		const currentCleanHref = window.location.href.replace(/\/?(\?|#|$)/, "").replace(/\/+$/, "");
		const newCleanHref = newUrl.replace(/\/?(\?|#|$)/, "").replace(/\/+$/, "");

		if (newCleanHref !== currentCleanHref) {
			history.pushState(state, "", newUrl);
		}
	}

	updatePagination(paginationData) {
		if (!this.paginationContainer.length) {
			return;
		}
		this.paginationContainer.empty();

		const totalPages = parseInt(paginationData.pages, 10);
		const currentPage = parseInt(paginationData.current_page, 10);

		if (isNaN(totalPages) || isNaN(currentPage) || totalPages <= 1) {
			return;
		}

		const prevText = "PREV";
		const nextText = "NEXT";

		let paginationHtml = `
            <div class="uk-width-1-1">
                <div class="uk-text-center uk-margin-xlarge-top uk-margin-auto">
                    <div class="uk-display-inline-block">
                        <ul class="uk-pagination" uk-margin>
        `;

		if (currentPage > 1) {
			paginationHtml += `<li class="pagination-prev"><a href="${this.getPageUrl(currentPage - 1)}">${prevText}</a></li>`;
		}

		const pageRange = 2;
		let startPage = Math.max(1, currentPage - pageRange);
		let endPage = Math.min(totalPages, currentPage + pageRange);

		if (startPage > 1) {
			paginationHtml += `<li><a href="${this.getPageUrl(1)}">1</a></li>`;
			if (startPage > 2) {
				paginationHtml += `<li class="uk-disabled"><span>...</span></li>`;
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			if (i === currentPage) {
				paginationHtml += `<li class="uk-active"><span>${i}</span></li>`;
			} else {
				paginationHtml += `<li><a href="${this.getPageUrl(i)}">${i}</a></li>`;
			}
		}

		if (endPage < totalPages) {
			if (endPage < totalPages - 1) {
				paginationHtml += `<li class="uk-disabled"><span>...</span></li>`;
			}
			paginationHtml += `<li><a href="${this.getPageUrl(totalPages)}">${totalPages}</a></li>`;
		}

		if (currentPage < totalPages) {
			paginationHtml += `<li class="pagination-next"><a href="${this.getPageUrl(currentPage + 1)}">${nextText}</a></li>`;
		}

		paginationHtml += `
                        </ul>
                    </div>
                </div>
            </div>
        `;
		this.paginationContainer.html(paginationHtml);

		if (window.UIkit && typeof window.UIkit.update === "function") {
			window.UIkit.update(this.paginationContainer[0]);
		}
	}

	bindEvents() {
		const handleChange = (event) => {
			const $checkbox = $(event.currentTarget);
			this.handleUserFilterChange(event.currentTarget);
		};

		if (this.industryCheckboxes.length > 0) {
			this.industryCheckboxes.on("change", handleChange);
		}

		if (this.categoryCheckboxes.length > 0) {
			this.categoryCheckboxes.on("change", handleChange);
		}

		$(document).on("click", ".dr-pagination-wrapper .uk-pagination a", (e) => {
			e.preventDefault();
			const $target = $(e.currentTarget);
			if ($target.closest("li").hasClass("uk-disabled") || $target.closest("li").hasClass("uk-active")) {
				return;
			}

			const urlString = $target.attr("href");
			if (urlString) {
				try {
					const url = new URL(urlString, window.location.href);
					let targetPageNum = 1;

					const pagedParam = url.searchParams.get("paged");
					if (pagedParam) {
						targetPageNum = parseInt(pagedParam, 10);
					} else {
						const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);
						if (pathMatch && pathMatch[1]) {
							targetPageNum = parseInt(pathMatch[1], 10);
						}
					}

					if (targetPageNum && !isNaN(targetPageNum) && targetPageNum !== this.currentPage) {
						this.currentPage = targetPageNum;
						this.applyFilters(false);
					}
				} catch (error) {
					console.error("Error parsing pagination URL:", error);
				}
			}
		});

		$(window).on("popstate", (event) => {
			if (event.originalEvent.state && event.originalEvent.state.filters) {
				const { filters, page } = event.originalEvent.state;
				this.currentPage = page || 1;

				// Reset all checkboxes first
				this.categoryCheckboxes.prop("checked", false);
				this.industryCheckboxes.prop("checked", false);

				let specificCategorySelected = false;
				if (filters.category && filters.category.length > 0) {
					filters.category.forEach((slug) => {
						this.updateSingleCheckboxState(this.categoryCheckboxes.filter(`[value="${slug}"]`), true);
					});
					specificCategorySelected = true;
				}
				this.updateSingleCheckboxState(this.categoryCheckboxes.filter('[value=""]'), !specificCategorySelected);

				let specificIndustrySelected = false;
				if (filters.industry && filters.industry.length > 0) {
					filters.industry.forEach((slug) => {
						this.updateSingleCheckboxState(this.industryCheckboxes.filter(`[value="${slug}"]`), true);
					});
					specificIndustrySelected = true;
				}
				this.updateSingleCheckboxState(this.industryCheckboxes.filter('[value=""]'), !specificIndustrySelected);

				this.applyFilters(false);
			}
		});
	}

	applyFilters(resetPage = true) {
		if (resetPage) {
			this.currentPage = 1;
		}

		if (this.isLoading) {
			if (this.currentXhr) {
				this.currentXhr.abort();
			}
		}
		this.isLoading = true;
		
		// Show skeleton and disable checkboxes during filtering
		this.toggleFilteringState(true);

		// Check if AJAX URL and nonce are defined
		if (!this.ajaxUrl || !this.nonce) {
			this.resultsContainer.html("<p>Error: AJAX configuration is incomplete</p>");
			this.isLoading = false;
			return;
		}

		const selectedFilters = this.getSelectedFilters();
		const requestData = {
			action: "ajax_blog_filter",
			nonce: this.nonce,
			page: this.currentPage,
			per_page: this.perPage,
		};

		// Add author information if we're on an author page
		if (this.isAuthorPage && this.authorSlug) {
			requestData.author_slug = this.authorSlug;
		}

		if (selectedFilters.category.length > 0) {
			requestData.category = selectedFilters.category;
		}
		if (selectedFilters.industry.length > 0) {
			requestData.industry = selectedFilters.industry;
		}

		// Use FormData for more reliable data transmission
		const formData = new FormData();

		// Add all parameters to FormData
		Object.keys(requestData).forEach((key) => {
			if (Array.isArray(requestData[key])) {
				// For arrays, add each element separately
				requestData[key].forEach((value) => {
					formData.append(`${key}[]`, value);
				});
			} else {
				formData.append(key, requestData[key]);
			}
		});

		this.currentXhr = $.ajax({
			url: this.ajaxUrl,
			type: "POST",
			data: formData,
			processData: false,
			contentType: false,
			dataType: "json",
			success: (response) => {
				if (response.success && response.data) {
					this.resultsContainer.html(response.data.html);
					this.updatePagination(response.data);
					this.updateAvailableTerms(response.data.available_terms);
					this.updateUrl();
					this.toggleFeaturedPostsVisibility();

					// Smooth scroll to the top of the posts container
					const postsContainer = document.querySelector(".dr-blog-posts-wrapper");
					if (postsContainer) {
						postsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
					}
				} else {
					let errorMessage = "Error loading posts. Please try again.";
					if (response && response.data && response.data.message) {
						errorMessage = response.data.message;
					}
					this.resultsContainer.html(`<p>${errorMessage}</p>`);
				}
			},
			error: (jqXHR, textStatus, errorThrown) => {
				if (textStatus !== "abort") {
					let errorMessage = "Error loading posts. Please try again.";
					try {
						const responseJson = JSON.parse(jqXHR.responseText);
						if (responseJson && responseJson.data && responseJson.data.message) {
							errorMessage = responseJson.data.message;
						}
					} catch (e) {
						// Error parsing JSON response
					}

					this.resultsContainer.html(`<p>${errorMessage}</p>`);
				}
			},
			complete: () => {
				this.isLoading = false;
				this.currentXhr = null;
				
				// Hide skeleton and enable checkboxes after filtering is complete
				this.toggleFilteringState(false);
			},
		});
	}

	/**
	 * Toggle filtering state - shows/hides skeleton and disables/enables filter checkboxes
	 * @param {boolean} isFiltering - Whether filtering is in progress
	 */
	toggleFilteringState(isFiltering) {
		// Toggle skeleton visibility
		if (isFiltering) {
			this.skeleton.addClass('uk-visible');
		} else {
			this.skeleton.removeClass('uk-visible');
		}
		
		// Toggle checkboxes disabled state
		this.industryCheckboxes.prop('disabled', isFiltering);
		this.categoryCheckboxes.prop('disabled', isFiltering);
	}

	updateAvailableTerms(availableTermsData) {
		if (!availableTermsData) {
			console.warn("updateAvailableTerms: No availableTermsData provided.");
			return;
		}

		// Update Category Filters
		if (availableTermsData.categories) {
			const availableCategorySlugs = availableTermsData.categories.map((term) => term.slug);
			this.categoryCheckboxes.each((_index, checkbox) => {
				const $checkbox = $(checkbox);
				const value = $checkbox.val();
				const $listItem = $checkbox.closest("li.ais-RefinementList-item");

				if (value === "") {
					// "All Topics" should always be visible
					$listItem.removeClass("uk-hidden");
					return;
				}
				if (availableCategorySlugs.includes(value)) {
					$listItem.removeClass("uk-hidden");
				} else {
					$listItem.addClass("uk-hidden");
				}
			});
		} else {
			// Show all categories if data is missing, or handle as an error
			this.categoryCheckboxes.closest("li.ais-RefinementList-item").removeClass("uk-hidden");
		}

		// Update Industry Filters
		if (availableTermsData.industries) {
			const availableIndustrySlugs = availableTermsData.industries.map((term) => term.slug);
			this.industryCheckboxes.each((_index, checkbox) => {
				const $checkbox = $(checkbox);
				const value = $checkbox.val();
				const $listItem = $checkbox.closest("li.ais-RefinementList-item");

				if (value === "") {
					// "All Industries" should always be visible
					$listItem.removeClass("uk-hidden");
					return;
				}
				if (availableIndustrySlugs.includes(value)) {
					$listItem.removeClass("uk-hidden");
				} else {
					$listItem.addClass("uk-hidden");
				}
			});
		} else {
			// Show all industries if data is missing
			this.industryCheckboxes.closest("li.ais-RefinementList-item").removeClass("uk-hidden");
		}
	}

	toggleFeaturedPostsVisibility() {
		if (!this.featuredPostsContainer.length) {
			return; // No container found
		}

		const selectedFilters = this.getSelectedFilters();
		const isAnyFilterActive = selectedFilters.category.length > 0 || selectedFilters.industry.length > 0;
		const isOnFirstPage = this.currentPage === 1;

		if (!isAnyFilterActive && isOnFirstPage) {
			this.featuredPostsContainer.show(); // Or slideDown(), etc.
		} else {
			this.featuredPostsContainer.hide(); // Or slideUp(), etc.
		}
	}
}

export default function () {
	$(document).ready(() => {
		if (typeof $ === "undefined") {
			return;
		}
		if ($(".js-blog-filters-form").length > 0) {
			new BlogFilter();
		}
	});
}
